import { render, staticRenderFns } from "./layout-null.vue?vue&type=template&id=4619c496&scoped=true&"
import script from "./layout-null.vue?vue&type=script&lang=js&"
export * from "./layout-null.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4619c496",
  null
  
)

export default component.exports